import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-sand py-16 sm:py-20" aria-labelledby="results-title" data-id="element-152" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-153" data-mp="28ddhzave4dr9">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-forest-900 sm:text-4xl" data-id="element-154" data-mp="2d6zw77h7cpp6">
          What educators using this teacher ready say
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-155" data-mp="2m6cwpancm3xr">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-earth-200 bg-white p-6 shadow-sm ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-156" data-mp="2r70woltk1v44" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-gold-500" aria-hidden="true" data-id="element-157" data-mp="3nfivwlxj8jlm" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-158" data-mp="3il4xeankpwcq">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-earth-100 pt-4" data-id="element-159" data-mp="3dnw9dtfquy3k">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-forest-800 text-sm font-extrabold text-gold-400" data-id="element-160" data-mp="38q4h2yb6t9yu">
                  {initials}
                </span>
                <span data-id="element-161" data-mp="58md51yjcn3p">
                  <b className="block text-sm text-forest-900" data-id="element-162" data-mp="5607j7v7gho4">{name}</b>
                  <small className="text-xs text-earth-500" data-id="element-163" data-mp="75g5hj69kse">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}